import { ref } from 'vue';

const visible = ref(false);
const message = ref('');
const type = ref('success');
let timer = null;

export const useToast = () => {
    /**
     * @param {string} msg - 提示文字
     * @param {'success' | 'warning' | 'error'} toastType - 状态类型
     */
    const showToast = (msg, toastType = 'success', duration = 2000) => {
        if (timer) clearTimeout(timer);

        message.value = msg;
        type.value = ['success', 'warning', 'error'].includes(toastType) ? toastType : 'success';
        visible.value = true;

        timer = setTimeout(() => {
            visible.value = false;
        }, duration);
    };

    return { visible, message, type, showToast };
};
